export const SITE_NAME = "دُکون بازار";
